<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-26 
-->
<template>
  <div>
    <van-popup v-model="modelIndex" position="bottom" round @close="resetForms">
      <div class="login-view">
        <div class="view-top">
          <div class="container-title">{{'欢迎使用VBEF观众登录系统' | dealLanguage('Welcome to the VBEF system')}}</div>
          <div class="container-desc">
            {{'您可以通过此系统报名参加展会开具发票' | dealLanguage('You can register for the exhibition and issue invoices through this system')}}<br />
            {{'非常感谢您的参与' | dealLanguage('Thank you very much for your participation')}}
          </div>
          <img :src="static_img_url+'pic/vbef.png?v=' + $store.state.imgVersion" />
        </div>
        <div class="view-container">
          <Form ref="code-form" :model="codeForm" :rules="ruleValidate">
            <FormItem prop="email">
              <div class="mobile-ipt">
                <Input type="text" v-model="codeForm.email" placeholder="Please enter your email address" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="codeForm.code" placeholder="Please enter verification code" autocomplete="off"></Input>
              <Captcha ref="captcha" scene="vbdata_loginon" :email="codeForm.email" validMode="2" v-if="modelIndex"></Captcha>
            </FormItem>
          </Form>
          <p class="tip">{{'未注册的手机号将自动创建动脉网账号' | dealLanguage('Unregistered mobile phone numbers will automatically create an VBEF account')}}</p>
          <van-button type="primary" block @click="handleSubmitEn">Sign in with Email</van-button>
          <div class="other">
            <div class="other-font">
              <span>Other</span>
            </div>
            <div class="other-container">
              <GoogleLogin :width="loginBtnWidth" uxMode="redirect" @success="handleGoogleLoginSuccess"></GoogleLogin>
              <LinkedinLogin></LinkedinLogin>
              <AppleLogin @success="handleAppleLoginSuccess"></AppleLogin>
            </div>
          </div>
          <div class="checkbox-container">
            By continuing, you agree to the CSGCT <a :href="index2_path+'/mobile/privacyPolicy/12'" target="_blank">Terms of Service</a>
            <br>
            and confirm that you have read our <a :href="index2_path+'/mobile/privacyPolicy/11'" target="_blank">Privacy Policy</a>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { loginCommon } from '@/assets/js/login'
import { editXuserChannelByLocalShareChannelId } from 'js/shareChannel'
import { mapState } from 'vuex'
import Captcha from '@/components/common/captcha'
import LinkedinLogin from '@/components/common/linkedinLogin'
import GoogleLogin from '@/components/common/googleLogin'
import AppleLogin from '@/components/common/appleLogin'
export default {
  mixins: [loginCommon],
  inject: ['reload', 'checkIfThereAreSendTickets'],
  components: { Captcha, LinkedinLogin, GoogleLogin, AppleLogin },
  created() {
    // this.updateRuleValidate()
  },
  mounted() {
    const clientWidth = document.documentElement.clientWidth
    this.loginBtnWidth = clientWidth - 80
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  data() {
    return {
      modelIndex: false,
      codeForm: {
        mobile: '',
        code: '',
      },
      loginBtnWidth: 0,
    }
  },
  methods: {
    loginSuccess(data) {
      this.$Message.success('Login successful')

      this.$store.commit('updateUserKey', data.userKey)
      this.$store.commit('updateUser', data.xuser)
      this.$store.commit('setUUserId', data.xuser.id)
      // return
      this.modelIndex = false

      this.reload()
      this.checkIfThereAreSendTickets()

      editXuserChannelByLocalShareChannelId(this.$store.state.activityId)
      if (this.successCb) this.successCb()
    },
    resetForms() {
      this.successCb = ''
      this.$refs['code-form'].resetFields()
    },
    /**
     * 谷歌登录授权成功回调
     */
    handleGoogleLoginSuccess(response) {
      const token = response && response.credential ? response.credential : null
      if (!token) return
      try {
        this.thirdPartyLogin(token, 9)
      } catch (err) {
        console.error('谷歌登录请求后端失败', err)
      }
    },
    /**
     * 苹果登录授权成功回调
     */
    async handleAppleLoginSuccess(res) {
      const { code, state } = res
      try {
        this.thirdPartyLogin(code, 10)
      } catch (err) {
        console.error('苹果登录请求后端失败', err)
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/login-m.styl'
.login-view 
  .view-container 
    .tip
      margin-top 0
  >>> .van-button--primary
    margin-top: 0.2rem;
.other
  display flex
  flex-direction column
.other-font
  position relative
  margin 16px 0
  width 100%
  &::before
    content ''
    border-bottom 1px solid #EEEEEE
    position absolute
    right 30px
    left 30px
    top 0
  span
    position absolute
    padding 0 20px
    background #fff
    left 50%
    top -7px
    font-size 12px
    color #999999
    line-height 17px
    transform translate(-50%, 0)
.other-container
  width 100%
  & > div
    &+div
      margin-top 0.2rem
</style>
